module.exports = __webpack_public_path__ + "./img/dots_vertical.svg";